import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8.487 21h7.026a4 4 0 0 0 3.808 -5.224l-1.706 -5.306a5 5 0 0 0 -4.76 -3.47h-1.71a5 5 0 0 0 -4.76 3.47l-1.706 5.306a4 4 0 0 0 3.808 5.224","key":"svg-0"}],["path",{"d":"M15 3q -1 4 -3 4t -3 -4z","key":"svg-1"}],["path",{"d":"M14 11h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5","key":"svg-2"}],["path",{"d":"M12 10v1","key":"svg-3"}],["path",{"d":"M12 17v1","key":"svg-4"}]]

const IconTax = createReactComponent('outline', 'tax', 'Tax', __iconNode);

export default IconTax;